import "./NursingCaregiverInModiinWithinFiveHours.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import CorridorPositionStatement from "./sections/CorridorPositionStatement";
import NursingServices from "./sections/NursingServices";
import DropCalendarFaq from "./sections/DropCalendarFaq";
import AppelALActionFinal from "./sections/AppelALActionFinal";
import Footer from "@/reusable_sections/Footer";
export default function NursingCaregiverInModiinWithinFiveHoursPage() {
  return <div>
      <Header />
      <HeroSection />
      <CorridorPositionStatement />
      <NursingServices />
      <DropCalendarFaq />
      <AppelALActionFinal />
      <Footer />
    </div>;
}